<template>
  <v-menu bottom left offset-y
    v-model="config.status.active"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <font-awesome-icon :icon="['fal', 'user']" />&nbsp;{{ printAuthorName }}
      </v-btn>
    </template>
    <v-list>
      <LogoutToolkit />
      <LoginToolkit @close="close" />
      <DevToolkit v-if="isDeveloper" />
    </v-list>
  </v-menu>
</template>

<script>
import LogoutToolkit from './logout'
import LoginToolkit from './login'
import DevToolkit from '@/components/dev'

export default {
  name: 'auth-toolkits',
  components: {
    LogoutToolkit,
    LoginToolkit,
    DevToolkit
  },
  data () {
    return {
      config: {
        status: {
          active: false
        }
      }
    }
  },
  methods: {
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isDeveloper () {
      let roles = this.$store.getters['author/get']('roles')
      return roles.includes('developer')
    },
    printAuthorName () {
      return this.$store.getters['author/get']('name')[0]
    }
  }
}
</script>
